if (!customElements.get('industries-slider')) {
  customElements.define(
    'industries-slider',
    class IndustriesSlider extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        if (this.dataset.enableSlider !== 'true') return;

        this.selectors = {
          sliderWrapper: '.industries__slider-wrapper',
          paginationEl: '.swiper-pagination',
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        };

        this.classes = {
          grid: 'f-grid',
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
        };

        this.sectionId = this.dataset.sectionId;
        this.section = this.closest(`.section-${this.sectionId}`);
        this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);
        this.enableSwipe = this.dataset.enableSwipe === 'true';

        this.sliderInstance = false;

        this.init();
      }

      init() {
        this.initSlider();
      }

      initSlider() {
        if (typeof this.sliderInstance === 'object') return;

        const columnGap = window.getComputedStyle(this.sliderWrapper).getPropertyValue('--column-gap');
        const spaceBetween = parseFloat(columnGap.replace('rem', '')) * 10;

        const sliderOptions = {
          slidesPerView: 1,
          spaceBetween: spaceBetween,
          navigation: {
            nextEl: this.section.querySelector(this.selectors.nextEl),
            prevEl: this.section.querySelector(this.selectors.prevEl),
          },
          pagination: {
            el: this.section.querySelector(this.selectors.paginationEl),
            clickable: true,
          },
          loop: false,
          autoHeight: true,
          threshold: 2,
        };

        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);
        this.sliderInstance = new window.AfcTheme.Carousel(this, sliderOptions);
        this.sliderInstance.init();

        const focusableElements = AfcTheme.a11y.getFocusableElements(this);

        focusableElements.forEach((element) => {
          element.addEventListener('focusin', () => {
            const slide = element.closest('.swiper-slide');
            this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
          });
        });

        // if (Shopify.designMode) {
        //   document.addEventListener('shopify:block:select', (e) => {
        //     if (e.detail.sectionId != this.sectionId) return;
        //     let { target } = e;
        //     const index = Number(target.dataset.index);

        //     this.sliderInstance.slider.slideToLoop(index);
        //   });
        // }
      }

      destroySlider() {
        this.classList.remove(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
        this.sliderWrapper.classList.add(this.classes.grid);

        if (typeof this.sliderInstance === 'object') {
          this.sliderInstance.slider.destroy();
          this.sliderInstance = false;
        }
      }
    }
  );
}
